import { gql } from 'apollo-angular';

export const CREATE_PARTNER = gql`
  mutation createPartner(
    $createPartnerInput: CreatePartnerInput!
    $createContactInputs: [CreateContactInput]
    $createAddressInputs: [CreateAddressInput]
    $createDocumentInputs: [CreateDocumentInput]
    $createRemarkInput: CreateRemarkInput!
  ) {
    createPartner(
      createPartnerInput: $createPartnerInput
      createContactInputs: $createContactInputs
      createAddressInputs: $createAddressInputs
      createDocumentInputs: $createDocumentInputs
      createRemarkInput: $createRemarkInput
    ) {
      id
    }
  }
`;

export const UPDATE_PARTNER = gql`
  mutation updatePartner(
    $updatePartnerInput: UpdatePartnerInput!
    $updateContactInputs: [UpdateContactInput]
    $updateAddressInputs: [UpdateAddressInput]
    $updateDocumentInputs: [UpdateDocumentInput]
    $updateRemarkInput: UpdateRemarkInput
  ) {
    updatePartner(
      updatePartnerInput: $updatePartnerInput
      updateContactInputs: $updateContactInputs
      updateAddressInputs: $updateAddressInputs
      updateDocumentInputs: $updateDocumentInputs
      updateRemarkInput: $updateRemarkInput
    ) {
      id
    }
  }
`;

export const REMOVE_PARTNER = gql`
  mutation removePartner($id: Int!) {
    removePartner(id: $id) {
      id
    }
  }
`;

export const CREATE_DOCUMENT = gql`
  mutation createDocument($createDocumentInput: CreateDocumentInput!) {
    createDocument(createDocumentInput: $createDocumentInput) {
      id
      partnerId
      partnerData {
        id
        partnerType
        customerType
        displayName
        companyName
        email
        phone
        mobile
        currency
        emirateID
        openingBalance
        paymentStatus
        status
        primaryContactId
      }
      documentName
      documentUrl
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const REMOVE_DOCUMENT = gql`
  mutation removeDocument($id: Int!) {
    removeDocument(id: $id)
  }
`;

export const CREATE_COMMENT = gql`
  mutation createComment($createCommentInput: CreateCommentInput!) {
    createComment(createCommentInput: $createCommentInput) {
      id
      employeeId
    }
  }
`;

export const CREATE_CONTACT = gql`
  mutation createContact($createContactInput: CreateContactInput!) {
    createContact(createContactInput: $createContactInput) {
      id
      salutation
      firstName
      lastName
      email
      phone
      mobile
      primaryContact
      status
      partnerId
      partner {
        id
        partnerType
        customerType
        displayName
        companyName
        email
        phone
        mobile
        currency
        emirateID
        openingBalance
        paymentStatus
        status
        primaryContactId
      }
    }
  }
`;

export const REMOVE_CONTACT = gql`
  mutation removeContact($id: Int!) {
    removeContact(id: $id)
  }
`;

export const UPDATE_CONTACT = gql`
  mutation updateContact($updateContactInput: UpdateContactInput!) {
    updateContact(updateContactInput: $updateContactInput) {
      id
      salutation
      firstName
      lastName
      email
      phone
      mobile
      primaryContact
      status
      partnerId
      partner {
        id
        partnerType
        customerType
        displayName
        paymentTerm
        companyName
        email
        phone
        mobile
        currency
        emirateID
        openingBalance
        paymentStatus
        status
        primaryContactId
      }
    }
  }
`;

export const CREATE_CUSTOMER = gql`
  mutation createCustomer(
    $createCustomerInput: CreateCustomerInput!
    $customerDocs: [CreateCustomerDocInput]
  ) {
    createCustomer(
      createCustomerInput: $createCustomerInput
      customerDocs: $customerDocs
    ) {
      id
    }
  }
`;
export const UPDATE_CUSTOMER = gql`
  mutation updateCustomer(
    $updateCustomerInput: UpdateCustomerInput!
    $customerDocs: [UpdateCustomerDocInput]
    $id: Int!
  ) {
    updateCustomer(
      updateCustomerInput: $updateCustomerInput
      customerDocs: $customerDocs
      id: $id
    ) {
      id
    }
  }
`;


export const REMOVE_CUSTOMER = gql`
  mutation removeCustomer($id: Int!) {
    removeCustomer(id: $id)
  }
`;


export const REMOVE_CUSTOMER_DOCUMENT = gql`
  mutation removeCustomerDoc($id: Int!) {
    removeCustomerDoc(id: $id)
  }
`;
